import { useClientRest } from "@shared/hooks";
import { toSnake, transformQueryParamsWithoutLocale } from "@shared/utils";
import { Kh_Government_Agencies } from "@sisnaker-react-core/karirhub-model-type";
import { useQuery } from "@tanstack/react-query";

export function useGovernmentAgencies({
  keyword,
  page = 1,
  limit = 10,
  enabled = true,
}: {
  keyword: string;
  page?: number;
  limit?: number;
  enabled?: boolean;
}) {
  const { request } = useClientRest();

  const query = useQuery<{ data: Kh_Government_Agencies[] }>({
    queryKey: ["common-government-agencies-", keyword, limit, page],
    queryFn: () =>
      request({
        url: transformQueryParamsWithoutLocale("/karirhub/onboarding/v2/government-agencies", toSnake({
          keyword,
          limit,
          page,
        })),
        method: "GET",
        options: {
          cache: "no-store",
        },
      }),
    enabled: enabled,
  });

  const refetch = () => {
    query.refetch();
  };

  return {
    isLoading: query.isLoading,
    governmentAgencies: query.data?.data || [],
    query,
    refetch,
  };
}
